module.exports = __webpack_public_path__ + "img/id-card-solid.fccbef04.svg";